module.exports = __webpack_public_path__ + "static/media/实践九号B星.80f35671.png";